import { Col } from '@/components/Col'
import { Row } from '@/components/Row'
import { TextSkeleton } from '@/components/skeletons/TextSkeleton'

import { SKELETONS_TEST_ID } from '@/utils/constants/testing/testsIds'
import styles from './styles.module.scss'

export function Skeleton() {
  return (
    <div className={styles.container} data-testid={SKELETONS_TEST_ID}>
      <Row gutter={40}>
        <Col span={5} className={styles.leftColumn}>
          <TextSkeleton width="7.6875rem" />
          <TextSkeleton width="15.6875rem" />
        </Col>

        <Col span={19} className={styles.rightColumn}>
          <TextSkeleton width="7.6875rem" />

          <Row gutter={8} className={styles.internalRow}>
            <TextSkeleton width="7.6875rem" />
            <TextSkeleton width="7.6875rem" />
          </Row>

          <TextSkeleton width="100%" />
          <TextSkeleton width="100%" />
          <TextSkeleton width="32.625rem" />
        </Col>
      </Row>

      <Row gutter={40}>
        <Col span={5} className={styles.leftColumn}>
          <TextSkeleton width="7.6875rem" />
          <TextSkeleton width="15.6875rem" />
        </Col>

        <Col span={19} className={styles.rightColumn}>
          <TextSkeleton width="7.6875rem" />
        </Col>
      </Row>

      <Row gutter={40}>
        <Col span={5} className={styles.leftColumn}>
          <TextSkeleton width="7.6875rem" />
          <TextSkeleton width="15.6875rem" />
        </Col>

        <Col span={19} className={styles.rightColumn}>
          <TextSkeleton width="7.6875rem" />

          <Row gutter={8} className={styles.internalRow}>
            <TextSkeleton width="7.6875rem" />
            <TextSkeleton width="7.6875rem" />
          </Row>

          <TextSkeleton width="100%" />
          <TextSkeleton width="100%" />
          <TextSkeleton width="32.625rem" />
        </Col>
      </Row>

      <Row gutter={40}>
        <Col span={5} className={styles.leftColumn}>
          <TextSkeleton width="7.6875rem" />
          <TextSkeleton width="15.6875rem" />
        </Col>

        <Col span={19} className={styles.rightColumn}>
          <TextSkeleton width="7.6875rem" />
          <TextSkeleton width="7.6875rem" />
        </Col>
      </Row>

      <Row gutter={40}>
        <Col span={24} className={styles.bottomSection}>
          <TextSkeleton width="7.6875rem" />
          <TextSkeleton width="7.6875rem" />
        </Col>
      </Row>
    </div>
  )
}
